import logo from "./logo.svg";
import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Love me some burritos. This site is under construction, fool.</h1>
      </header>
    </div>
  );
}

export default App;
